import gql from "graphql-tag";

const GET_LIQUIDM_PUBLISHER_SITES = gql`
  query liquidMPublisherSites($page: JSON, $filter: LiquidMSitesInput) {
    liquidMPublisherSites(page: $page, filter: $filter)
  }
`;

export default GET_LIQUIDM_PUBLISHER_SITES;
